import { render, staticRenderFns } from "./ThemeMultibarChart.vue?vue&type=template&id=6630ede4&scoped=true&"
import script from "./ThemeMultibarChart.vue?vue&type=script&lang=js&"
export * from "./ThemeMultibarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6630ede4",
  null
  
)

export default component.exports